import { grey } from '@mui/material/colors';
import React from 'react';
import Image from '~/components/Image';

interface FaviconImageProps extends React.ComponentProps<typeof Image> {
  domain: string;
  hideOnError?: boolean;
}
export const FaviconImage = ({
  domain,
  hideOnError,
  ...imageProps
}: FaviconImageProps) => {
  const src = `https://img.logo.dev/${domain}?token=${import.meta.env.VITE_LOGO_DEV_API_KEY}`;

  return (
    <Image
      src={src}
      alt={`${domain} icon`}
      sx={{
        objectFit: 'contain',
        border: `solid 1px ${grey[300]}`,
      }}
      onError={(e) => {
        if (hideOnError) {
          e.currentTarget.style.display = 'none';
        } else {
          const fallback = `${
            import.meta.env.VITE_STATIC_ASSETS_URL
          }/reports/0.jpg`;
          if (e.currentTarget.src !== fallback) {
            e.currentTarget.src = fallback;
          }
        }
      }}
      {...imageProps}
    />
  );
};
